import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import Icon from '../../../Icons'
import DetailsItem from '../components/DetailsItem/DetailsItem'
import { mapRewardSettingsDetails } from '../helpers'

const RewardsRewardDetailsModal = ({ onClose = () => {}, reward }) => {
  const { t } = useTranslation(['rewards-table'])
  const items = [
    {
      data: mapRewardSettingsDetails(reward, t),
    },
  ]

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={t('rewards-table:rewardDetailsHeaderTitle')}
      headerIcon={<Icon icon="cup" />}
    >
      <div
        className="rewards-modal-content rewards-base-view reward-details"
        style={{ paddingBottom: 20 }}
      >
        {items.map((item, index) => (
          <DetailsItem data={item.data} title={item.title} key={index} />
        ))}
      </div>
    </ModalContainer>
  )
}

RewardsRewardDetailsModal.propTypes = {
  onClose: PropTypes.func,
  reward: PropTypes.object,
}

export default RewardsRewardDetailsModal
